
export const AWS_COGNITO_CONFIG = {

    UserPoolId: process.env.REACT_APP_USERPOOL_ID,
    ClientId: process.env.REACT_APP_CLIENT_ID,
    Region: process.env.REACT_APP_REGION
}